<script lang="ts">
    import { blur } from 'svelte/transition';

    import type { RoutePointExtendedType } from '../../../utilities/RoutePointsApi';
    import AssignmentJobOne from './AssignmentJobOne.svelte';
    import { debug, scenarioManager } from '../../../../stores/store';
    import { Assignment } from '../Assignment';
    import type { Vehicle } from '../../Vehicles/Vehicle';
    import type { AssignmentJob } from '../AssignmentJob';
    import type { DisplayShapeType } from './types';
    import { type ReorderedRouteType } from '../AssignmentApi';
    import { type RoutePointAlertsType } from '../AssignmentApi';
    import { dla } from './DeliveryListApp/dla';
    import { rsa } from './RouteSummaryApp/rsa';
    import type { PlanningOnMap } from '../PlanningOnMap';
    import { captureMessage } from '@sentry/svelte';

    export let assignment: Assignment;
    export let routePoint: RoutePointExtendedType | null = null;
    export let modifiedRouteData: ReorderedRouteType | null = null;
    export let routeDirty: boolean;
    export let expandedIndex: number[] = [];
    export let planningOnMap: PlanningOnMap;
    export let minimizeViewTimeWindow: boolean = false;
    export let disabled: boolean = false;

    let expanded: boolean = false;

    let alerts: RoutePointAlertsType = {};

    let vehiclesAssignments: { id: number; vehicle_id: number }[] = [];
    let vehicles: Vehicle[] = [];

    let reassignJob = () => {
        alert('not implemented reassignJob');
    };
    let onRouteSelect = () => {
        alert('not implemented onRouteSelect');
    };
    let onFilterChange = () => {};
    let unassignedSection = new Assignment({});
    let allAssignments: Assignment[] = $scenarioManager.getScenarioSections(false, false, false);

    let routePointJobs =
        routePoint !== null
            ? $dla.getFilteredItems().filter(aj => routePoint?.jobs?.includes(aj.getJobId()))
            : [];
    if (routePoint?.jobs && routePointJobs.length < routePoint?.jobs?.length) {
        routePointJobs = routePointJobs.concat(
            Object.values($dla.getRejectedJobsAsAssignmentJobs(true, routePoint.jobs))
        );
    }
    let visibleRoutePointJobs: AssignmentJob[] = [];

    let nextRoutePointJobId: number[] = [];

    // if ($debug && routePoint) {
    //     if (routePoint.point_order === 2) {
    //         // FIXME: remove from production -- double point for testing
    //         routePointJobs = [...routePointJobs, ...routePointJobs];
    //     }
    //     if (routePoint.point_order === 3) {
    //         // FIXME: remove from production -- triple point for testing
    //         routePointJobs = [...routePointJobs, ...routePointJobs, ...routePointJobs];
    //     }
    // }

    function getDisplayShape(index: number, expanded: boolean): DisplayShapeType {
        if (routePointJobs.length === 1) {
            return 'single-middle';
        }
        if (expanded) {
            if (index === 0) {
                return 'multi-first';
            }
            if (index === routePointJobs.length - 1) {
                return 'multi-last';
            }
            return 'multi-middle';
        } else {
            return 'multi-collapsed';
        }
    }

    $: {
        if (routePoint) {
            try {
                routePointJobs = $dla
                    .getFilteredItems()
                    .filter(aj => routePoint?.jobs?.includes(aj.getJobId()));
                if (routePoint?.jobs && routePointJobs.length < routePoint?.jobs?.length) {
                    routePointJobs = routePointJobs.concat(
                        Object.values($dla.getRejectedJobsAsAssignmentJobs(true, routePoint.jobs))
                    );
                }
                if (routePointJobs.length > 0) {
                    routePointJobs[0].setRoutePoint(routePoint);
                    visibleRoutePointJobs = expanded ? routePointJobs : routePointJobs.slice(0, 1);
                    if (assignment.isDownloaded()) {
                        nextRoutePointJobId = $dla.getNextRoutePointJobId();
                    } else {
                        nextRoutePointJobId = [];
                    }
                }
                let routeInfo = assignment.getRouteInfo();
                if (routeInfo) {
                    let routeAlerts = routeInfo.alerts;
                    if (
                        $rsa.selectedRouteType === 'current_in_realisation' &&
                        assignment.getRouteInRealisation()
                    ) {
                        routeAlerts = assignment.getRouteInRealisation()?.alerts;
                    } else if (routeInfo.reorder_stack) {
                        routeAlerts =
                            routeInfo.reorder_stack[routeInfo.reorder_stack.length - 1].alerts;
                    }
                    if (routeAlerts) {
                        for (let type in routeAlerts) {
                            if (
                                type != 'time_window' &&
                                routeAlerts[type][routePoint.point_order]
                            ) {
                                alerts[type] = routeAlerts[type][routePoint.point_order];
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error processing routePointJobs:', error);
                captureMessage('Error processing routePointJobs:', {
                    extra: {
                        error,
                    },
                });
                visibleRoutePointJobs = [];
                alerts = {};
            }
        }
    }
</script>

{#each visibleRoutePointJobs as assignmentJob, index}
    <div in:blur|global>
        <AssignmentJobOne
            {disabled}
            displayMode="routePoint"
            displayShape={getDisplayShape(index, expanded)}
            simpleView={true}
            bind:expanded
            canBeExpanded={routePointJobs.length > 1}
            bind:assignmentJob
            bind:assignment
            {unassignedSection}
            showHeader={false}
            {onFilterChange}
            {reassignJob}
            {onRouteSelect}
            {planningOnMap}
            {vehiclesAssignments}
            {vehicles}
            {allAssignments}
            {modifiedRouteData}
            {routeDirty}
            {nextRoutePointJobId}
            routePointAlerts={alerts}
            bind:expandedIndex
            {minimizeViewTimeWindow}
        />
    </div>
{/each}
